export enum OrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  SUSPENDED = 'suspended',
}

export interface Coin {
  _id: string
  name: string
  image: string
  symbol: string
  ticker: string
  rate: string | number
  paymentAddress: string
}

export interface Order {
  _id: string
  coin: Coin
  user: any
  type: string
  email: string
  price: number
  quantity: number
  total: number
  totalInCrypto?: number
  cryptoRate?: number
  status: OrderStatus
  images: string[]
  note?: string
  comment?: string
  createdAt?: string
  updatedAt?: string
}
